import React from 'react';
import styled from 'styled-components';
import { STATIC_IMAGES } from '@constants';
import { generateSlideImageUrl } from '@utils/generateAssetLinks';
import { Line } from '../styles';

const Image = styled.img`
    margin: 15px;
    ${props => props.height && `height: ${props.height}`};
    ${props => props.width && `width: ${props.width}`};
`;

export const StratAndTrustPilot = ({ stratLogoDimensions, trustPilotDimensions, showLine = false }) => {
    const { stratLogoLarge, trustPilotStars } = STATIC_IMAGES;

    return (
        <div>
            <Image 
                height={stratLogoDimensions.height ?? null}
                width={stratLogoDimensions.width ?? null}
                alt={stratLogoLarge} 
                src={generateSlideImageUrl(stratLogoLarge)}/>
            { showLine && <Line />}
            <Image 
                height={trustPilotDimensions.height ?? null}
                width={trustPilotDimensions.width ?? null}
                alt={trustPilotStars} 
                src={generateSlideImageUrl(trustPilotStars)}/>
        </div>
    );
};

export default StratAndTrustPilot;
